import { Box } from "@mui/material";

export function ChartPolkaDotLegend({ color }: { color: string }) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 3px)",
                gridTemplateRows: "repeat(3, 3px)",
                gap: "2px",
                width: "13px",
                height: "13px"
            }}
        >
            {Array(9)
                .fill(null)
                .map((_, i) => (
                    <Box
                        key={i}
                        sx={{
                            width: "3px",
                            height: "3px",
                            borderRadius: "50%",
                            backgroundColor: color,
                            opacity: 0.5
                        }}
                    />
                ))}
        </Box>
    );
}
export function ChartSolidDotLegend({ color, size = 8 }: { color: string; size?: number }) {
    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: "50%",
                backgroundColor: color,
                display: "inline-block"
            }}
        />
    );
}
